import { render, staticRenderFns } from "./Seat.vue?vue&type=template&id=007b45d6&scoped=true&"
import script from "./Seat.vue?vue&type=script&lang=js&"
export * from "./Seat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b45d6",
  null
  
)

export default component.exports